import { AppModal } from 'shared/UI/UIKit/Modal';
import { DateForm } from 'features/production-calendar/components/Form';
import type { Month } from 'features/production-calendar/components/types';
import { DateModalFooter } from '../../Footer';
import { useCreateDateService } from '../model';

interface CreateDateModalProps {
  visible: boolean;
  onItemCreate: () => void;
  hide: () => void;
  calendarYear?: string;
  calendarMonth?: Month;
}

export const CreateDateModal = ({
  visible,
  onItemCreate,
  hide,
  calendarYear = '',
  calendarMonth,
}: CreateDateModalProps) => {
  const {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  } = useCreateDateService({ hide, onItemCreate });

  const footer = <DateModalFooter onSubmit={onSubmit} hideModal={hideModal} title="Создать" />;
  const content = (
    <DateForm form={form} calendarYear={calendarYear} calendarMonth={calendarMonth!} />
  );

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      maskClosable={false}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Добавить дату"
    />
  );
};
